import Menu from "./modules/menu";
import Theme from "./modules/theme";
import Exapnd from "./modules/exapand";
import Filter from "./modules/filter";
import AboutBook from "./modules/aboutBook";
import Slick from "./modules/slick";
import InputNumber from "./modules/inputNumber";
import Dots from "./modules/dots";

Menu.init();
Theme.init();
Exapnd.init();
Filter.init();
AboutBook.init();
Slick.init();
InputNumber.init();
Dots.init();
